import React from 'react';
import vitalSourceLogo from "../../img/vst_logo_signin.svg";
import supportLogo from "../../img/circle_support.svg";

export default function LoginFooter() {
    return (
        <div className="login-bottom-bar">
            <span className="login-strapline">Powered by<img className="login-strapline-img" src={vitalSourceLogo} alt="VitalSource" /></span>
            <span className="login-support">
                <a className="support-link" target="_blank" rel="noopener noreferrer"
                    href="https://success.vitalsource.com/hc/en-us/categories/23251248756503-Studio">
                    <img className="login-support-img" src={supportLogo} alt="" /><span>Support</span>
                </a>
            </span>
        </div>
    );
}
